import Glitter from './modules/Glitter';

const glitter = new Glitter();
glitter.init();
